exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Cookie--fleetware{background:#e5f5cf;color:#599900;padding:1.25em}.Cookie--fleetware .Cookie__button{background:#599900;padding:.625em 3.125em;color:#fff;border-radius:5px;border:0;font-size:1em}.Cookie--fleetware .Cookie__button:hover{background:#62a800}", ""]);

// exports
